// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"364":"f2401971","750":"9a01c460"}[chunkId] + ".css";
};